export const Role = {
    SuperAdmin: 'Super Admin',
    HoManager: 'HO Manager',
    CinemaManager: 'Cinema Manager',
    PosOperator: 'POS Operator',
    // PosOperator: 'POS Operator',
    PosFnBOperator: 'FnB POS Operator',
    Distributor: 'Distributor',
    BoxOfficeFnbOperator: 'Box Office Fnb',
    AnalyticsManager: 'Analytics Manager',
    KitchenManager: 'Kitchen Manager',
    ProgrammingManager: 'Programming Manager'
} 

export const CLIENT_NAME = {
    CINEMA_AKIL: 'Cinema Akil',
   
} 


// WEBPACK FOOTER //
// ./src/helper/Role.js